export default "__VITE_ASSET__BO6K_yyH__"